import { AgentStepFormComponent } from './agent-step-form/agent-step-form.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../auth-guard.service';

import { AgentSearchComponent } from './agent-search/agent-search.component';
import { AgentProfileComponent } from './agent-profile/agent-profile.component';
import { AgentCheckerSearchComponent } from './agent-checker-search/agent-checker-search.component';
import { AgentReviewStepFormComponent } from './agent-review-step-form/agent-review-step-form.component';
import { AgentPaymentViewComponent } from './agent-payment-view/agent-payment-view.component';
import { AgentTransferToApplicantComponent } from './agent-transfer-to-applicant/agent-transfer-to-applicant.component';
import { AgentRejectViewComponent } from './agent-reject-view/agent-reject-view.component';
import { AgentRecruitmentStepFormComponent } from './agent-recruitment-step-form/agent-recruitment-step-form.component';

const routes: Routes = [
  {
    path: 'agent/:id',
    // component: AgentStepFormComponent,
    component: AgentRecruitmentStepFormComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'agent',
    component: AgentStepFormComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'agent-search',
    component: AgentSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'agent-graph-search',
    component: AgentSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'profile',
    component: AgentProfileComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'profile/:id',
    component: AgentProfileComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'checker-search',
    component: AgentCheckerSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'checker-graph-search',
    component: AgentCheckerSearchComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'review/:id',
    component: AgentReviewStepFormComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'payment-review/:id',
    component: AgentPaymentViewComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'agent-applicant/:id',
    component: AgentTransferToApplicantComponent,
    canActivate: [AuthGuardService],
  },
  {
    path: 'agent-reject-view/:id',
    component: AgentRejectViewComponent,
    canActivate: [AuthGuardService],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AgentRoutingModule {}
